import React from 'react';

export default function PurchaseSuccess() {
  return (
    <React.Fragment>
      <p>Success</p>
    </React.Fragment>
  )
}